module.exports = __webpack_public_path__ + "img/ACH.9e1b8f2b.png";